import React from 'react'
import styles from './pages.module.scss'

const FinalSpecs = () => {
  return <div className={styles.gallery}>FinalSpecs</div>
}

export default FinalSpecs
